import HeaderBar from './HeaderBar.component';

export default HeaderBar;
